import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    getAppContentDetails: {},
    appContentListLoading: false,
    appContentListSuccess: null,
    appContentListError: '',
    homeButtonLoading: false,
    homeButtonSuccess: {}
}

export const appContentSlice = createSlice({
    name: 'appcontent',
    initialState,
    reducers: {
        appContentData: (state, action) => {
            state.getAppContentDetails = action.payload;
        },
        setAppContentListLoading: (state) => {
            state.appContentListLoading = true;
            state.appContentListSuccess = null;
            state.appContentListError = '';
        },
        setAppContentListSuccess: (state, action) => {
            state.appContentListLoading = false;
            state.appContentListSuccess = action.payload;
            state.appContentListError = '';
        },
        setAppContentListError: (state, action) => {
            state.appContentListLoading = false;
            state.appContentListSuccess = null;
            state.appContentListError = action.payload;
        },
        setHomePageButtonLoading: (state) => {
            state.homeButtonLoading = true;
            state.homeButtonSuccess = null;
        },
        setHomePageButtonSuccess: (state, action) => {
            state.homeButtonLoading = false;
            state.homeButtonSuccess = action.payload;
        },
        resetAppContent: (state) => {
            state.getAppContentDetails = {}
        },
        resetHomeButtonData: (state) => {
            state.getAppContentDetails = {}
        },
    }
})

// Action creators are generated for each case reducer function
export const { appContentData, setAppContentListLoading, setAppContentListSuccess, setHomePageButtonLoading, setHomePageButtonSuccess, setAppContentListError, resetAppContent } = appContentSlice.actions

export default appContentSlice.reducer;